"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents the view model used for 'create new' menu item
 */
var http_1 = require("@angular/common/http");
var CreateNewModel = /** @class */ (function () {
    function CreateNewModel(_id, _icon, _titleKey, _routeLink, _permissionKey, _openNewWindow) {
        if (_openNewWindow === void 0) { _openNewWindow = false; }
        this._id = _id;
        this._icon = _icon;
        this._titleKey = _titleKey;
        this._permissionKey = _permissionKey;
        this._openNewWindow = _openNewWindow;
        var queryParams = new Map();
        queryParams.set('fullScreen', _openNewWindow);
        if (_routeLink.includes('?')) {
            var urlParts = _routeLink.split('?');
            this._routeLink = urlParts[0];
            var httpParams_1 = new http_1.HttpParams({ fromString: urlParts[1] });
            httpParams_1.keys().forEach(function (paramName) { return queryParams.set(paramName, httpParams_1.get(paramName)); });
        }
        else {
            this._routeLink = _routeLink;
        }
        this._routeLinkQueryParams = Array.from(queryParams).reduce(function (obj, _a) {
            var key = _a[0], value = _a[1];
            obj[key] = value;
            return obj;
        }, {});
    }
    Object.defineProperty(CreateNewModel.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateNewModel.prototype, "icon", {
        get: function () {
            return this._icon;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateNewModel.prototype, "routeLink", {
        get: function () {
            return this._routeLink;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateNewModel.prototype, "permissionKey", {
        get: function () {
            return this._permissionKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateNewModel.prototype, "titleKey", {
        get: function () {
            return this._titleKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateNewModel.prototype, "openNewWindow", {
        get: function () {
            return this._openNewWindow;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateNewModel.prototype, "routeLinkQueryParams", {
        get: function () {
            return this._routeLinkQueryParams;
        },
        enumerable: true,
        configurable: true
    });
    return CreateNewModel;
}());
exports.CreateNewModel = CreateNewModel;
//# sourceMappingURL=create-new.model.js.map